"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconResources = function IconResources(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconResources', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.93 15.5a.5.5 0 0 1-.484-.374A1.497 1.497 0 0 0 6 14H1.25A1.25 1.25 0 0 1 0 12.75V2.25C0 1.56.56 1 1.25 1H6c.817 0 1.544.394 2 1.002A2.496 2.496 0 0 1 10 1h.022a.51.51 0 0 1 .024 0h4.705C15.44 1 16 1.56 16 2.25v10.5c0 .69-.56 1.25-1.25 1.25H10.024a1.497 1.497 0 0 0-1.468 1.126.5.5 0 0 1-.484.374H7.93zM5.954 2H1.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25H6c.557 0 1.08.185 1.5.504V3.5C7.5 2.673 6.827 2 6 2h-.045zM10 2c-.778 0-1.42.596-1.493 1.356L8.5 3.5v10.004A2.482 2.482 0 0 1 10 13h.022a.51.51 0 0 1 .024 0h4.705a.25.25 0 0 0 .249-.25V2.25a.25.25 0 0 0-.25-.25H10.024A.51.51 0 0 1 10 2zm-4 8a.5.5 0 1 1 0 1H2.5a.5.5 0 1 1 0-1H6zm7.5 0a.5.5 0 1 1 0 1H10a.5.5 0 1 1 0-1h3.5zM6 8a.5.5 0 0 1 0 1H2.5a.5.5 0 1 1 0-1H6zm7.5 0a.5.5 0 1 1 0 1H10a.5.5 0 1 1 0-1h3.5zM6 6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1H6zm7.5 0a.5.5 0 1 1 0 1H10a.5.5 0 1 1 0-1h3.5zM6 4a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1H6zm7.5 0a.5.5 0 1 1 0 1H10a.5.5 0 1 1 0-1h3.5z"
  }));
};

var _default = IconResources;
exports.default = _default;